module.exports = __webpack_public_path__ + "img/service.264b6c7c.svg";